var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cn-product-page-skeleton"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cn-product-page-skeleton__breadcrumbs py-4"},[_c('UiSkeletonElement',{style:({
          width: 'calc(16 * var(--size-base))',
          height: 'var(--size-xl)',
        })})],1),_vm._v(" "),_c('div',{staticClass:"cn-product-page-skeleton__content"},[_c('UiSkeletonElement',{style:({
          width: '100%',
          aspectRatio: '1 / 1',
        })}),_vm._v(" "),_c('div',{staticClass:"cn-product-page-skeleton__text"},[_c('UiSkeletonElement',{style:({
            width: '100%',
            height: 'calc(6 * var(--size-base))',
          })}),_vm._v(" "),_c('div',{staticClass:"cn-product-page-skeleton__block"},[_c('UiSkeletonElement',{style:({
              width: 'calc(12 * var(--size-base))',
              height: 'var(--size-4xl)',
            })})],1),_vm._v(" "),_c('div',{staticClass:"cn-product-page-skeleton__block"},[_c('UiSkeletonElement',{style:({
              width: 'calc(12 * var(--size-base))',
              height: 'var(--size-4xl)',
            })})],1),_vm._v(" "),_c('div',{staticClass:"cn-product-page-skeleton__chars py-8"},[_c('UiSkeletonElement',{style:({
              width: '50%',
              height: 'calc(24 * var(--size-base))',
            })})],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }